/*
Copyright 2016 Gábor Mező (gabor.mezo@outlook.com)

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

'use strict';
var es5Support = require('../lib/es5Support');

if (!es5Support.fallbackToES5(exports, 'test')) {
    require('./suites/dynload');
    require('./suites/smokeTests');
    require('./suites/raii');
    require('./suites/refTypes');
    require('./suites/synchModes');
    require('./suites/ffiCompatibility');
    require('./suites/declare');
}